import React from 'react';

export default class Email extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      changed: false
    };
    this.intervalId = -1;
  }

  componentWillUnmount(){
    if(this.state.changed)
      this.up();
  }

  componentDidUpdate(prevProp, prevState){
    if(prevProp.value !== this.props.value){
      this.setState({
        value: this.props.value,
        changed: true,
      }, () => { setTimeout(() => { this.up() }, this.props.ix * 1000) })
    }
  }

  handleChange = (e) => {
    const val = e.target.value;
    this.setState({
      value: val,
      changed: true
    }, ()=>{
      clearInterval(this.intervalId);
      this.intervalId = setTimeout(() => { this.up() }, (this.props.ix * 10) + 500);
    })
    e.preventDefault();
  }

  validateEmail = (email) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
  }

  handleFocus(event) {
    event.target.select();
  }

  onBlur = () => {
    this.up();
  }

  up = () =>{
    if((this.state.changed==true)&&(this.props.callback!=null)&&(this.validateEmail(this.state.value))){
      this.props.callback({
        field: this.props.name,
        value: this.state.value
      });
      if(this.props.hasOwnProperty('onChange'))
        this.props.onChange();
    }
    this.setState({
      changed: false
    })
    clearInterval(this.intervalId);
  }

  render() {
    return (
        <input
          type="email"
          name={this.props.name}
          placeholder={"email"}
          value={this.state.value}
          className="form-control"
          autoComplete="off"
          onInput={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.up}
          required={this.props.required}
        />
    );
  }
}
